export default "__VITE_ASSET__CXKeyRuO__"